// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cookies_configurator_modal{z-index:999!important}.cookies_configurator_modal .complaint_modal__ttl_wrapper{margin-bottom:33px}.cookies_configurator_modal__instructions,.cookies_configurator_modal__preference{margin-bottom:24px}.cookies_configurator_modal__preference--ttl_wrapper{margin-bottom:21px}.cookies_configurator_modal__button{padding-top:22px;padding-bottom:22px;transition:.4s}@media (min-width:1024px){.cookies_configurator_modal__button:hover{background-color:#613dd1}}", ""]);
// Exports
module.exports = exports;
